// packages/web-ui/src/components/kb-browser/rank-entities.ts
//
// Story W4-S5 (AC #2.4) — local rank function for the KB Browser search.
//
// W4-S5 local rank function — replaced by rankCandidates from
// @tessa-lean/base in W4-S6 per FR-KB-4. Do not extend this — the stable API
// is the @tessa-lean/base helper.

import type { KbEntity } from '@tessa-lean/base/api-schemas/index.js';

const SCORE_PREFIX = 100;
const SCORE_SUBSTRING = 30;
const SCORE_NAME_SUFFIX = 20;

function scoreEntity(entity: KbEntity, query: string): number {
  const qn = entity.qualifiedName.toLowerCase();
  const q = query.toLowerCase();
  let score = 0;
  if (qn.startsWith(q)) score += SCORE_PREFIX;
  if (qn.includes(q)) score += SCORE_SUBSTRING;
  // Match against the simple name (the segment after the last `::`).
  const parts = entity.qualifiedName.split('::');
  const simpleName = (parts[parts.length - 1] ?? '').toLowerCase();
  if (simpleName.includes(q)) score += SCORE_NAME_SUFFIX;
  return score;
}

/**
 * Rank entities by relevance to `query`. When the query is empty the input
 * array is returned unchanged (preserves the parent-grouping order). When
 * non-empty, scores are computed per-entity and the array is sorted by
 * (score desc, qualifiedName asc).
 */
export function rankEntities(entities: KbEntity[], query: string): KbEntity[] {
  if (query.length === 0) return entities;
  const scored = entities.map((entity) => ({
    entity,
    score: scoreEntity(entity, query),
  }));
  scored.sort((a, b) => {
    if (a.score !== b.score) return b.score - a.score;
    return a.entity.qualifiedName.localeCompare(b.entity.qualifiedName);
  });
  return scored.map(({ entity }) => entity);
}
